import { gql } from "apollo-boost";

const PAYMENTS_QUERY = gql`
  query Payments {
    user {
      first_name
      last_name
      email
      credit {
        credit_limit
        credit_used
        credit_available
      }
      rewards {
        available_points
      }
      card {
        status
      }
      payment_methods {
        id
        nickname
        institution
        logo
        logoURL
        type
        account_number_last_four
      }
      default_payment_method_id
      payment_due_date
      payment_due_balance
      delinquent
      alternative_payment_link
      autopay_frequency
      next_trigger_date
      pending_activity_summary {
        count
        volume
      }
    }
  }
`;

const PAYMENTS_LIST_QUERY = gql`
  query Payments(
    $status: String
    $fromDate: String
    $toDate: String
    $page: Int
    $perPage: Int
  ) {
    payments(
      status: $status
      fromDate: $fromDate
      toDate: $toDate
      page: $page
      perPage: $perPage
    ) {
      created_at
      updated_at
      settled_at
      returned_at
      amount
      status
      category
      is_paid_by_user
    }
  }
`;

export { PAYMENTS_QUERY, PAYMENTS_LIST_QUERY };
